import ApiClient from './ApiClient';

class CompanyNotes extends ApiClient {
  constructor() {
    super('notes', { accountScoped: true });
    this.companyId = null;
  }

  get url() {
    return `${this.baseUrl()}/companies/${this.companyId}/notes`;
  }

  get(companyId) {
    this.companyId = companyId;
    return super.get();
  }

  create(companyId, content) {
    this.companyId = companyId;
    return super.create({ content });
  }

  update(companyId, id, content) {
    this.companyId = companyId;
    return super.update(id, { content });
  }

  delete(companyId, id) {
    this.companyId = companyId;
    return super.delete(id);
  }
}

export default new CompanyNotes();
